module.exports = __webpack_public_path__ + "img/user.a17b559f.png";